export default function productClassMessaging({ messages, excludeFromPromo, isPerksEligible }) {
    const ignoreExclusionMessages = excludeFromPromo ? messages.filter(message => message.ignoreExclusions === 'true') : messages;

    let message = isPerksEligible
        ? ignoreExclusionMessages.find(message => message.customer === 'Subscriber')
        : ignoreExclusionMessages.find(message => message.customer === 'Non Subscriber');

    if (!message) {
        message = ignoreExclusionMessages.find(message => message.customer === 'Default');
    }

    return message || null;
}